import { render, staticRenderFns } from "./DistributionsListPage.vue?vue&type=template&id=486886b0&"
import script from "./DistributionsListPage.vue?vue&type=script&lang=js&"
export * from "./DistributionsListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports